import React, { useEffect } from "react";
import { useDropzone } from "react-dropzone";
import "./Dropzone2.css";
import Photo from "../assets/profile.jpg";
import swal from "sweetalert";
import { getCampaignImageUrl } from "../../config";
export default function Dropzone(props) {
  const [files, setFiles] = React.useState([]);
  const { getRootProps, getInputProps } = useDropzone({
    accept: "image/*",
    onDrop: acceptedFiles => {
      if (acceptedFiles[0].size < 500000) {
        setFiles(
          acceptedFiles.map(file =>
            Object.assign(file, {
              preview: URL.createObjectURL(file)
            })
          )
        );
      } else {
        swal({
          title: "Image size should be less than 500kb",
          icon: "warning"
        });
      }
    }
  });
  useEffect(() => {
    if (files.length && files !== undefined)
      props.setFilePreview(files, setFiles);
    files.forEach(file => {
      URL.revokeObjectURL(file.preview);
      props.setFilePreview(file);
    });
  }, [files]);
  const thumbs =
    files.length === 0 ? (
      <div>
        {props.formData.campaignLogo !== null &&
        props.formData.campaignLogo !== "" ? (
          <img
            src={getCampaignImageUrl.url + props.formData.campaignLogo}
            style={{ width: "80px", height: "auto", minHeight: "80px" }}
          />
        ) : (
          <img src={Photo} style={{ width: "80px", height: "80px" }} />
        )}
      </div>
    ) : (
      files.map(file => (
        <div key={file.name}>
          <div>
            <img
              src={file.preview}
              style={{ width: "80px", height: "auto", minHeight: "80px" }}
            />
          </div>
        </div>
      ))
    );
  return (
    <div className="Dropzone">
      {thumbs}
      <div {...getRootProps({ className: "dropzone" })}>
        <input {...getInputProps()} />
        <aside className="Camera">
          <i className="fa fa-camera" />
          <span className="text">Change Logo</span>
        </aside>
      </div>
    </div>
  );
}
